import styled, { css } from 'styled-components';
import { StyledLink } from '../styles/ui';
import { fontSemibold16 } from '../styles/fonts';
import { Colors } from '../../../theme';
import { HEADER_TYPE } from '../types';
import { breakpointLG } from '../styles/breakpoints';
const basicLinkStyle = css `
  flex: 1;
  text-align: center;
  padding: 8px 16px;
  ${fontSemibold16}
  border-radius: 4px;
`;
export const Wrapper = styled.section `
  width: 100%;
  height: 70px;
  position: fixed;
  padding: 0 16px;
  box-sizing: border-box;
  ${(props) => props.$type === HEADER_TYPE.Integrated
    ? css `
          top: 70px;
        `
    : css `
          bottom: 0;
        `}
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.white};
  border-top: ${(props) => props.$type === HEADER_TYPE.Integrated ? '0' : `solid 1px ${Colors.black40}`};
  border-bottom: ${(props) => props.$type === HEADER_TYPE.Integrated ? `solid 1px ${Colors.black40}` : '0'};

  @media (min-width: ${breakpointLG}) {
    display: none;
  }
`;
export const CustomLink = styled(StyledLink) `
  &.MuiLink-root {
    ${basicLinkStyle}
    border: solid 1px ${Colors.blue60};

    color: ${Colors.blue60};

    &:hover,
    &:focus,
    &:active {
      color: ${Colors.blue60};
      background-color: ${Colors.white};
    }
  }
`;
export const RegistrationLink = styled(StyledLink) `
  &.MuiLink-root {
    ${basicLinkStyle}
    margin-left: 8px;

    color: ${Colors.white};
    background-color: ${Colors.blue60};

    &:hover,
    &:focus,
    &:active {
      color: ${Colors.white};
      background-color: ${Colors.blue60};
    }
  }
`;
//# sourceMappingURL=styles.js.map